import { render, staticRenderFns } from "./MyPrefecture.vue?vue&type=template&id=2e17e0ba&scoped=true&"
import script from "./MyPrefecture.vue?vue&type=script&lang=js&"
export * from "./MyPrefecture.vue?vue&type=script&lang=js&"
import style0 from "./MyPrefecture.vue?vue&type=style&index=0&id=2e17e0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17e0ba",
  null
  
)

export default component.exports